import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const photoFileUrl = (id, opts = {}) => {
  const t = typeof localStorage !== "undefined" ? localStorage.getItem("token") : null;
  const params = [];
  if (opts.thumb) params.push("thumb=1");
  if (t) params.push(`token=${encodeURIComponent(t)}`);
  return `${API}/photos/${id}/file${params.length ? `?${params.join("&")}` : ""}`;
};

export function eventApi(eventId) {
  const inst = axios.create({ baseURL: `${API}/events/${eventId}` });
  inst.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  inst.interceptors.response.use(
    (r) => r,
    (error) => {
      const d = error.response?.data?.detail;
      if (error.response?.status === 403 && d && d.code === "FEATURE_LOCKED"
          && typeof window !== "undefined" && !window.location.pathname.endsWith("/pricing")) {
        window.location.assign(`/e/${eventId}/pricing?highlight=${d.bundle || d.feature}`);
      }
      return Promise.reject(error);
    }
  );
  return inst;
}

export default api;
